import PageLayout from 'components/layout/PageLayout';
import PDFLayout from 'components/layout/PDFLayout';
import { useLocation } from "react-router-dom";
import ScrollToTop from './services/scrollToTop';

function App() {
  const location = useLocation();

  function Layout() {
    if(location.pathname === '/pdf'){
      return <PDFLayout />
    } else {
      return <PageLayout />
    }
  }

  return (
    <div className="App">
      <ScrollToTop/>
      <Layout />
    </div>
  );
}

export default App;
